import React from "react";
import { UserCircleIcon } from "@heroicons/react/24/solid";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import useFileUpload from "../../hooks/useFileUpload";

const AvatarUpload = React.forwardRef(
  (
    {
      onRemoveHandler,
      onRemoveConfirmHandler,
      filelist,
      defaulturl,
      label,
      description,
      uniqueId = "avatar-upload",
      ...props
    },
    ref
  ) => {
    const { previewUrl, handleRemove, handleChange } = useFileUpload({
      defaultUrl: defaulturl,
      fileList: filelist,
      onRemoveHandler,
      onRemoveConfirmHandler,
      inputId: uniqueId,
    });

    return (
      <div>
        <label
          htmlFor={uniqueId}
          className="block text-sm font-medium text-ink-900 mb-2"
        >
          {label}
        </label>

        {description && (
          <p className="text-sm text-ink-600 mb-2">{description}</p>
        )}

        {/* Hidden file input */}
        <input
          id={uniqueId}
          name={props.name}
          type="file"
          className="sr-only"
          ref={ref}
          accept={props.accept}
          {...props}
        />

        <div className="mt-2 flex flex-col space-y-4">
          {previewUrl ? (
            <>
              <img
                src={previewUrl}
                alt="Preview"
                className="size-20 rounded-full object-cover border border-ink-100"
              />
              <div className="flex items-center gap-2">
                <SecondaryButton onClick={handleChange} colour="gray">
                  Change
                </SecondaryButton>
                <PrimaryButton colour="red" onClick={handleRemove}>
                  Remove
                </PrimaryButton>
              </div>
            </>
          ) : (
            <>
              <UserCircleIcon className="size-20 text-ink-300" />
              <div className="flex items-center">
                <PrimaryButton
                  onClick={() => document.getElementById(uniqueId)?.click()}
                >
                  Upload Photo
                </PrimaryButton>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
);

export default AvatarUpload;
